import { Directive, HostListener } from '@angular/core';
import { Location } from '@angular/common';

@Directive({
    selector: '[u2bBrowserBackOnClick]',
    standalone: false
})
export class BackButtonDirective {

    constructor(private _location: Location) {
    }

    @HostListener('click', ['$event'])
    protected _onClick(event): void {
        event.preventDefault();
        this._location.back();
        return;
    }

}
